/**
 * cardSelectData — configuration for the `CardSelect` picker.
 *
 * `CardSelect` shows every option at once as a row of small cards: a bold
 * identifier over a smaller name. It is the short-list counterpart to `connect`,
 * which opens a modal to search a long one, and it is configured the same way —
 * an `entity` to read and a `valueMap` saying which fields the choice writes
 * back — so moving a picker between the two is a change of `type`, not a rewrite.
 *
 * An entry is named by `configRef`, from a cardView element or from a page
 * component. That indirection is the point: the component knows how a card
 * looks, and this file knows what is on it.
 *
 *   titleField    the bold line — an identifier short enough to scan (a code)
 *   subField      the smaller line under it; omit for a single-line card
 *   valueMap      form field → source field, exactly as `connect` uses it.
 *                 Only read when the picker sits in a form
 *   orderBy       field the cards are sorted on; defaults to `titleField`
 *   persistKey    when set, the last choice is remembered across visits under
 *                 this key. Leave it off for a picker bound to a record — a
 *                 form field must show the record's value, not the last one
 *                 the user happened to pick somewhere else
 *   size          'small' | 'medium' | 'large' — the whole visual scale of a
 *                 card. A caller may override it per use
 *
 * Keys stay in alphabetical order, like every sibling map.
 */
export const cardSelectData = {
    warehouseSelect: {
        id: 'warehouseSelect',
        titleField: 'code',
        subField: 'name',
        label: 'warehouse.select.label',
        emptyMessage: 'warehouse.select.empty',
        entity: 'warehouse',
        valueMap: {
            'warehouseId': 'id',
            'warehouseCode': 'code',
            'warehouseName': 'name'
        },
        orderBy: 'code',
        persistKey: 'warehouseLayout',
        size: 'small'
    }
}